export default __webpack_public_path__ + "static/media/wait.dbb452a3.png";